import {UseQueryOptions} from '@tanstack/react-query';
import {twMerge} from '../common/twMerge';
import {Loading} from '../design-system/atoms/Loading/Loading';
import {ReactQueryFetcherChildrenType} from './CodegenReactQueryType.type';

export function ReactQueryFetcherChildren<TQuery, TError>({
  children,
  isLoading,
  ignoreLoading,
  isFetching,
  ignoreFetching,
  loadingWrapperClassName,
  data,
  options,
}: {
  children?: ReactQueryFetcherChildrenType<TQuery>;
  isLoading: boolean;
  ignoreLoading?: boolean;
  isFetching: boolean;
  ignoreFetching?: boolean;
  loadingWrapperClassName?: string;
  data?: TQuery;
  options?: Omit<UseQueryOptions<TQuery, TError>, 'queryKey'>;
}) {
  // enabled : false 라면 Fetch 할 필요가 없는 경우라는 의미로 자식을 그대로 보여줍니다.
  if (options?.enabled === false) {
    return <>{children}</>;
  }

  if ((isLoading && !ignoreLoading) || (isFetching && !ignoreFetching)) {
    return (
      <div className={twMerge(loadingWrapperClassName, 'flex-center-full')}>
        <Loading />
      </div>
    );
  }

  if (data) {
    if (typeof children === 'function') {
      return <>{children(data)}</>;
    }
    return <>{children}</>;
  }
  return null;
}
